import React from 'react';
import { Link } from 'react-router-dom';
import SocialShareButtons from './SocialShareButtons';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const resolveImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${BACKEND_URL}${url}`;
};

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('id-ID', {
    day: 'numeric', month: 'long', year: 'numeric',
  });
};

const ArticleCard = ({ article }) => (
  <div className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-lg transition-all duration-300 h-full flex flex-col">
    <Link to={`/artikel/${article.slug}`}>
      {article.featured_image ? (
        <div className="overflow-hidden">
          <img
            src={resolveImageUrl(article.featured_image)}
            alt={article.title}
            className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
      ) : (
        <div className="w-full h-48 bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
          <span className="text-4xl text-blue-200">AF</span>
        </div>
      )}
      <div className="p-5 pb-0 flex-1 flex flex-col">
        {article.category && (
          <span className="inline-block text-xs font-medium text-blue-600 bg-blue-50 px-2.5 py-0.5 rounded-full mb-2 self-start">
            {article.category}
          </span>
        )}
        <h3 className="font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">
          {article.title}
        </h3>
        {article.excerpt && (
          <p className="text-sm text-gray-600 line-clamp-3 flex-1">{article.excerpt}</p>
        )}
        <div className="mt-3 text-xs text-gray-400">
          {article.author && <span>{article.author}</span>}
          {article.author && article.published_at && <span className="mx-1">&middot;</span>}
          {article.published_at && <span>{formatDate(article.published_at)}</span>}
        </div>
      </div>
    </Link>
    <div className="px-5 pb-5">
      <SocialShareButtons
        url={`${window.location.origin}/artikel/${article.slug}`}
        shareUrl={`${BACKEND_URL}/api/share/artikel/${article.slug}`}
        title={article.title}
        compact
      />
    </div>
  </div>
);

export default ArticleCard;
